function getKeyChains() {
  return Array.from(this.keyChains.values());
}

module.exports = getKeyChains;
